import api from './api';

const authService = {
  // Login user
  login: async (username, password, remember = false) => {
    const response = await api.post('/users/login', {
      username,
      password,
      remember,
    });
    return response;
  },

  // Verify OTP
  verifyOTP: async (otp) => {
    const response = await api.post('/users/verify-otp', {
      otp,
    });
    return response;
  },

  // Logout user
  logout: async () => {
    const response = await api.post('/users/logout');
    return response;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get('/users/me');
    return response;
  },

  // Check session status
  checkSession: async () => {
    const response = await api.get('/users/session-status');
    return response;
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/users/change-password', {
      currentPassword,
      newPassword,
    });
    return response;
  },

  // Forgot password
  forgotPassword: async (email) => {
    const response = await api.post('/users/forgot-password', {
      email,
    });
    return response;
  },

  // Reset password
  resetPassword: async (token, password) => {
    const response = await api.post('/users/reset-password', {
      token,
      password,
    });
    return response;
  },
};

export default authService;
